
import {WOW} from '../../../node_modules/wowjs/dist/wow';
new WOW().init();
// import AOS from 'aos';               
// import '../styles/aos.css';

// AOS.init({
//   disable: false,
//   duration: 500,
//   offset: 30,
//   easing: 'ease-in-out-sine'
// });
// new WOW({
//   offset: 100
// }).init();
